// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Tabs_tabsContainer__1O47g","buttonsBlock":"Tabs_buttonsBlock__3CFYf","button":"Tabs_button__1S7Vh","buttonActive":"Tabs_buttonActive__1_v4S"};